// VISINVOKE World Explorer - public SEO page builder.
// Source-driven only: every fact below is from the packaged open geography (GeoNames, CC BY 4.0),
// not generative filler. Pages are deterministic and bounded to a curated set; the live product
// covers the full world data pack. Mirrors the Animal/Music SEO builders.

export const WORLD_SEO_PLACES = Object.freeze({
  australia: Object.freeze({ name: 'Australia', kind: 'Country', capital: 'Canberra', continent: 'Oceania', iso: 'AU / AUS', source: 'GeoNames' }),
  japan: Object.freeze({ name: 'Japan', kind: 'Country', capital: 'Tokyo', continent: 'Asia', iso: 'JP / JPN', source: 'GeoNames' }),
  france: Object.freeze({ name: 'France', kind: 'Country', capital: 'Paris', continent: 'Europe', iso: 'FR / FRA', source: 'GeoNames' }),
  brazil: Object.freeze({ name: 'Brazil', kind: 'Country', capital: 'Brasília', continent: 'South America', iso: 'BR / BRA', source: 'GeoNames' }),
  canada: Object.freeze({ name: 'Canada', kind: 'Country', capital: 'Ottawa', continent: 'North America', iso: 'CA / CAN', source: 'GeoNames' }),
  kenya: Object.freeze({ name: 'Kenya', kind: 'Country', capital: 'Nairobi', continent: 'Africa', iso: 'KE / KEN', source: 'GeoNames' }),
});

const QUESTIONS = Object.freeze({
  'what-is-the-capital-of-australia': Object.freeze({
    title: 'What is the capital of Australia?',
    answer: 'The capital of Australia is Canberra. Its largest city is Sydney; the capital and the largest city are different places.',
    places: ['australia'],
  }),
  'what-continent-is-japan-in': Object.freeze({
    title: 'What continent is Japan in?',
    answer: 'In the World Explorer geography, Japan is in Asia. Its capital is Tokyo.',
    places: ['japan'],
  }),
});

function safeSlug(value) { return typeof value === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value) ? value : null; }

export function buildWorldSeoPage(kind, params = {}) {
  if (kind === 'country') {
    const slug = safeSlug(params.slug);
    const place = slug && WORLD_SEO_PLACES[slug];
    if (!place) return null;
    return { kind, title: `${place.name}`, description: `Capital, continent, ISO codes and world-geography context for ${place.name}, with sources kept visible.`, places: [place] };
  }
  if (kind === 'compare') {
    const leftSlug = safeSlug(params.left); const rightSlug = safeSlug(params.right);
    const left = leftSlug && WORLD_SEO_PLACES[leftSlug]; const right = rightSlug && WORLD_SEO_PLACES[rightSlug];
    if (!left || !right || leftSlug === rightSlug) return null;
    return { kind, title: `${left.name} vs ${right.name}`, description: `A source-aware comparison of ${left.name} and ${right.name}: capital, continent and ISO codes.`, places: [left, right] };
  }
  if (kind === 'question') {
    const slug = safeSlug(params.slug); const question = slug && QUESTIONS[slug];
    if (!question) return null;
    return { kind, title: question.title, description: question.answer, answer: question.answer, places: question.places.map((placeSlug) => WORLD_SEO_PLACES[placeSlug]) };
  }
  return null;
}

export function worldSeoPaths() {
  const countries = Object.keys(WORLD_SEO_PLACES).map((slug) => `/world-explorer/country/${slug}`);
  const questions = Object.keys(QUESTIONS).map((slug) => `/world-explorer/questions/${slug}`);
  return [...countries, ...questions];
}
